import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import rootReducer from './rootReducer';

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: [
    'layout',
    'toast',
    'tasks',
    'taskForm',
    'files',
    'error',
    'position',
    'route',
    // features
    'user',
    'client',
    'venue',
    'operating',
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const logger = createLogger();

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    });

    if (import.meta.env.NODE_ENV === 'development') {
      return middleware.concat(logger);
    } else {
      return middleware;
    }
  },

  devTools: import.meta.env.NODE_ENV === 'development',
});

export default store;
